import React from 'react';
import Aboutme from './aboutme';
import Skills from './skills';
import Education from './education';
import Projects from './projects';
import Contact from './contact';

function Main() {
    
    return <main> <Aboutme /> <Skills /> <Education /> <Projects /> <Contact /></main>
}

export default Main;